import { maps } from "core/util";

const getPredictions = (searchText) => maps.doGetPlacePredictions(searchText);
const getPlaceDetail = (placeId) => maps.doGetPlaceDetail(placeId);

export default {
    getPredictions,
    getPlaceDetail,
};
